import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api/rest-api.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from '../configuration/configuration.service';
import { EnvironmentService } from '../environment/environment.service';

@Injectable()
export class NavigationService {
    public loaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public navigationObj$: BehaviorSubject<Array<any>> = new BehaviorSubject(null);
    public fullNavigation$: BehaviorSubject<any> = new BehaviorSubject(null);
    public footerObj$: BehaviorSubject<Array<any>> = new BehaviorSubject(null);
    public fullNavigationData: any = <any>{};
    private navigationData: Array<any> = [];
    private footerData: Array<any> = [];
    private _site: string;

    constructor(private _restApi: RestApiService,
        private _configService: ConfigurationService
    ) {
        
    }

    async _loadAllNavigationData(): Promise<boolean> {
        const _site = this._configService.getCurrentSite();
        let _url = `${environment.locales}assets/navigation/${_site}.json`;
        return this._restApi.requestGET<any>(_url).then(
            (data: any) => {
                this.fullNavigationData = data.Navigation;
                this.navigationData = data.Navigation?.Children.filter((item) => !item.IsHidden);
                // this.footerData = data.Footer.Children;
                this._publishNavigationData();
                return true;
            },
            () => {
                return false;
            }
        );
    }

    private _publishNavigationData() {
        this.loaded$.next(true);
        this.fullNavigation$.next(this.fullNavigationData);
        this.navigationObj$.next(this.navigationData);
        this.footerObj$.next(this.footerData);
    }
}
